import { css } from '@emotion/css'
import { theme } from '@contrast-security-inc/design-system-foundations'

export const styles = {
  gridPanelCard: css`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(1, auto);
    row-gap: -5px;
  `,
  libraryOverviewCVEScore: (color: string) => css`
    margin-left: 10px;
    margin-right: 26px;
    max-height: 26px;
    font-size: 20px;
    font-weight: bold;
    color: ${color};
    margin-top: -4px;
  `,
  caret: css`
    margin-bottom: -6px;
    cursor: pointer;
  `,
  linkCaret: css`
    cursor: pointer;
  `,
  panelCard: css`
    min-width: 100%;
    max-height: 100px;
    margin-top: 15px;
    background: white;
    box-shadow: unset;
    border: 1.5px solid ${theme.color.neutral40};
  `,
  panelData: css`
    color: black;
    font-size: 12px;
    margin-top: -25px;
    text-transform: capitalize;
    font: Noto Sans;
  `,
  appColumnPanel: css`
    margin-top: 10px;
  `,
  serverCount: css`
    font-size: 20px;
    font-weight: 600;
    color: ${theme.color.neutral70};
    font: Noto Sans Display;
    margin-top: 14px;
    margin-left: -10px;
  `,

  appPanel: css`
    color: black;
    font-size: 16px;
    font: Lato;
    margin-left: 20px;
  `,
  tabProviderOrgPanel: css`
    margin-top: 20px;
    margin-bottom: 100px;
  `,
  badgeStyle1s: css`
    margin-left: 10px;
    margin-right: 26px;
    max-width: 40px;
    min-width: 70px;
    max-height: 26px;
  `,

  impactedStats1: css`
    margin-top: 10px;
    font-size: 24px;
    font-weight: 600;
    font: Noto Sans Display;
  `,

  impactPercent: css`
    font-size: 18px;
    font-weight: 600;
    margin-top: 15px;
    font: Noto Sans Display;
  `,

  cve1: css`
    font-size: 18px;
    font-weight: 600;
    font-color: ${theme.color.neutral100};
    font: Noto Sans Display;
    cursor: pointer;
    line-height: 18px;
    display: flex;
    align-items: center;
  `,
  unknownSeverity: css`
    margin-top: 20px;
  `,
  cve0: css`
    font-size: 12px;
    font-weight: 600;
    font-color: ${theme.color.neutral100};
    line-height: 18px;
    width: 108px;
    height: 20px;
  `,

  cve2: css`
    margin-top: 12px;
    font-size: 12px;
    color: ${theme.color.neutral70};
    gap: 20px;
  `,
  vectorTitle: css`
    margin-bottom: 16px;
    margin-top: 40px;
  `,

  descriptionBody: css`
    white-space: pre-wrap;
    word-wrap: break-word;
    width: 100%;
  `,
  orgImpactTitle: css`
    margin-bottom: 16px;
    margin-top: 30px;
  `,
  epss: css`
    margin-bottom: -13px;
    border-bottom: 1.6px dashed ${theme.color.black};
  `,
  exploitabilityScore: css`
    margin-bottom: 25px;
    border-bottom: 1.6px dashed ${theme.color.black};
  `,
  impactScore: css`
    margin-bottom: 25px;
    border-bottom: 1.6px dashed ${theme.color.black};
  `,
  cvssTitle: css`
    margin-bottom: 25px;
    border-bottom: 1.6px dashed ${theme.color.black};
  `,
  severityAndMetrics: css`
    display: flex;
    flex-wrap: wrap;
    // margin-bottom: -125px;
  `,
  severityAndMetricsTitle: css`
    margin-bottom: 16px;
  `,
  drawerFormat: css`
        top: 50px !important;
        z-index: 1001;
        max-width: 57%; !important;
      `,
  cveHeaderStyles: css`
    display: grid;
    grid-template-columns: 250px 200px;
  `,
  nvdLink: css`
    margin-top: -3px;
    font-size: 12px;
  `,
  linkIcon: css`
    padding-left: 5px;
  `,
  cveLink: css`
    margin-top: -3px;
    font-size: 12px;
  `,
  vectorFormat: css`
    margin-bottom: 16px;
    margin-top: 50px;
  `,
  vectorCard: css`
    background: ${theme.color.neutral10};
    width: 100%;
    height: auto;
    box-shadow: unset;
    margin-top: 15px;
  `,
  vectorGridCVSS: css`
    display: grid;
    display: flex;
    flex-wrap: wrap;
    grid-template-columns: repeat(8, 1fr);
    grid-template-rows: repeat(2, auto);
    row-gap: -5px;
    column-gap: 20px;
    width: 100%;
  `,
  vectorGridTitle: css`
    margin-bottom: 16px;
    border-bottom: 1.6px dashed ${theme.color.black};
    color: ${theme.color.neutral70};
    font-size: 12px;
    font: Noto Sans;
  `
}
